import { ActiveFilter } from '../types'

export const getActiveFromFilter = (
  filter?: ActiveFilter,
): boolean | undefined => {
  if (!filter) return
  if (filter.active && filter.inactive) return
  if (filter.active === false && filter.inactive === false) return
  if (filter.active === undefined && filter.inactive === undefined) return

  return filter.active === true
}
